define('atendimentos-controller',[
    'atendimentos-resource',
    'directive/ng-flow/dist/ng-flow-standalone.min',
    'directive/flow.js/dist/flow.min',
    'directive/ng-flow/dist/ng-flow.min',
    'angular-file-upload',
], function() {

    var app = angular.module('atendimentos.controller', [
        'atendimentos.resource',
        'ui.mask',
        'flow',
    ]);

    app.controller('AtendimentosControllerIndex', ['$scope', '$rootScope', 'Atendimentos', '$mdDialog', function($scope, $rootScope, Atendimentos, $mdDialog) {
        $scope.atendimentos = {
            ato_datasolicitacao: new Date(),
            ato_status: 'P',
            ato_estado: 'N',
            ato_meio: 'O'
        };

        $scope.status = [
            { ato_status:'F', nome: 'Finalizado' },
            { ato_status:'A', nome: 'Em andamento' },
            { ato_status:'P', nome: 'Pendente' },
        ];

        $scope.estado = [
            { ato_estado:'A', nome: 'Alta' },
            { ato_estado:'N', nome: 'Normal' },
            { ato_estado:'B', nome: 'Baixa' },
        ];

        $scope.meios = [
            {nome: 'Site', ato_meio: 'S'},
            {nome: 'Telefone', ato_meio: 'T'},
            {nome: 'Pessoalmente', ato_meio: 'P'},
            {nome: 'Whatsapp', ato_meio: 'W'},
            {nome: 'E-mail', ato_meio: 'E'},
            {nome: 'Outros', ato_meio: 'O'}
        ];

        $scope.openModalUploads = function(item) {
            Atendimentos.getUploadsAtendimento({ato_codigo: item.ato_codigo}).then(function (r) {
                angular.extend($scope, r);
                $rootScope.gotoTop();
                $mdDialog.show({
                        controller: $scope => $scope.atendimentoUploads = r.atendimentoUploads,
                        templateUrl: '/site/public/includes/area-cliente/atendimentos/modal-anexos.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: false,
                    })
                    .then(function(answer) {
                        $scope.status = '';
                    }, function() {
                        $scope.status = '';
                    });
            })
        }


        $scope.atendimentos = atendimentos;
        console.log(atendimentos);
    }]);



    app.controller('AtendimentosControllerAdd', ['$scope', '$rootScope', 'Atendimentos','$selectUIService', function($scope, $rootScope, Atendimentos, $selectUIService) {

        $scope.selectedContrato = null;
        $scope.atendimentos = {
            ato_datasolicitacao: new Date(),
            ato_status: 'P',
            ato_estado: 'N',
            ato_meio: 'O'
        };

        $scope.status = [
            { ato_status:'F', nome: 'Finalizado' },
            { ato_status:'A', nome: 'Em andamento' },
            { ato_status:'P', nome: 'Pendente' },
        ];

        $scope.estado = [
            { ato_estado:'A', nome: 'Alta' },
            { ato_estado:'N', nome: 'Normal' },
            { ato_estado:'B', nome: 'Baixa' },
        ];

        $scope.meios = [
            {nome: 'Site', ato_meio: 'S'},
            {nome: 'Telefone', ato_meio: 'T'},
            {nome: 'Pessoalmente', ato_meio: 'P'},
            {nome: 'Whatsapp', ato_meio: 'W'},
            {nome: 'E-mail', ato_meio: 'E'},
            {nome: 'Outros', ato_meio: 'O'}
        ];



        $scope.atendimento = {
            ato_solicitacao: null,
            ato_datacadastro: new Date(moment().format("YYYY-MM-DD")),
            ato_datasolicitacao: new Date(moment().format("YYYY-MM-DD")),
            ato_status: $scope.status[2].ato_status,
            con_codigo:  $scope.selectedContrato,
            pes_codigo: null,
            imo_codigo: null,
            ato_meio: $scope.meios[0].ato_meio,
            ato_prazo: null,
            ato_estado: $scope.estado[1].ato_estado,
            ato_status_moderacao_atendimento: "PENDENTE",
        };


        $scope.setModel= function(model, value){
            $scope[model] = value;
        };
        $scope.solicitacaoEnviada = false;
        $scope.contratos = contratos;
        $scope.atendimento.atend_codigocreate = null;

        $scope.enviarSolicitacao = function(){
            $scope.atendimento.con_codigo = $scope.selectedContrato;
            
            Atendimentos.create($scope.atendimento).then(function (result) {
                if(result.success){
                    $scope.solicitacaoEnviada = true;
                    $scope.atendimento.atend_codigocreate = result.atend_codigo;
                    alert('Solicitação de atendimento enviada !');
                }
            }).catch(function (err) {
                console.error(err);
            });
        };

        $scope.redirectlist = function () {
            window.location.href = '/areacliente/atendimentos';
        }

        $scope.totalFiles = 0;
        $scope.limiteDeUpload = 5;

        $scope.submitFlow =  function($flow) {
            $scope.totalFiles = $flow.files.length; // limitando upload de arquivos
            if($scope.totalFiles > $scope.limiteDeUpload){
                //removendo fotos até chegar no número permitido
                for(var i = $flow.files.length; i > $scope.limiteDeUpload; i--){
                    $flow.files.pop(); // removendo ultimo arquivo
                }
                $scope.totalFiles = $scope.limiteDeUpload;
            }
            // Enviar arquivo inteiro para o endpoint genérico (sem chunking)
            $flow.opts.forceChunkSize = false;
            $flow.opts.chunkSize = 1024 * 1024 * 1024; // 1GB para evitar divisão em chunks
            $flow.opts.target = '/areacliente/atendimentos/uploadArquivo/' + $scope.atendimento.atend_codigocreate;
            $flow.upload();
        };

        $scope.sucessUploadImg =  function (file, $message, $flow ) {
            var $self = $('.flow-file-'+file.uniqueIdentifier);
            // Reflect that the file upload has completed
            $self.find('.flow-file-complete span').text('Completo');
            $self.find('.flow-file-pause').hide();
            $self.find('.flow-file-cancel').hide();
            $scope.flowReset = $flow;
            var data = {
                atend_codigo: $scope.atendimento.atend_codigocreate,
                file: {
                    name:file.file.name,
                    type:file.file.type,
                    identifier:file.uniqueIdentifier
                }
            };
            Atendimentos.successUploadImgAtendimento(data).then(function(result){
                $scope.totalFiles--;
                if($scope.totalFiles == 0){
                    console.log('Upload Concluido');
                    // window.location.href = '/';
                }
            });
        };

    }]);
});

